import React, { useEffect, useState } from "react";

import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

import { inputMask } from "../../../utils/helpers/masks/masks";
import { validation } from "../../../utils/helpers/masks/validations";

export default function EmailInput({
  deleteComponent,
  rowId,
  colId,
  attributes,
  setAttributes,
  autoOpen = false,
  groups = [],
}) {
  const [inputName, setInputName] = useState(
    attributes ? attributes.inputName : "Email",
  );
  const [label, setLabel] = useState(attributes ? attributes.label : "Email");
  const [placeholder, setPlaceholder] = useState(
    attributes ? attributes.placeholder : "Digite seu email",
  );
  const [tipText, setTipText] = useState(
    attributes ? attributes.tipText : "Texto dica",
  );
  const [hasTip, setHasTip] = useState(attributes ? attributes.hasTip : false);
  // Segregação por grupos — se `groupIds` tiver itens, o campo só é
  // visível pros participantes desses grupos.
  const [groupIds, setGroupIds] = useState(attributes?.groupIds || []);

  // Mask
  const [maskedValue, setMaskedValue] = useState("");

  // Validação
  const [emailError, setEmailError] = useState("");

  // Edit Modal
  const [editModal, setEditModal] = useState(false);

  useEffect(() => {
    if (autoOpen) setEditModal(true);
  }, []);

  const handleChange = (value) => {
    inputMask({ value, setMaskedValue });
  };

  useEffect(() => {
    const { isValid, message } = validation(maskedValue, "email");
    setEmailError(maskedValue && !isValid ? message : "");
  }, [maskedValue]);

  useEffect(() => {
    if (!attributes) {
      setAttributes({
        rowId,
        colId,
        attributes: {
          inputName: "Email",
          label: "Email",
          placeholder: "Digite seu email",
          tipText: "Texto dica",
          hasTip: false,
          mask: "email",
          required: true,
          uniqueField: "email",
          columnValue: "email",
        },
      });
    }
  }, [rowId, colId, setAttributes, attributes]);

  const submitForm = (e) => {
    e.preventDefault();
    setAttributes({
      rowId,
      colId,
      attributes: {
        inputName,
        label,
        placeholder,
        tipText,
        hasTip,
        mask: "email",
        required: true,
        uniqueField: "email",
        columnValue: "email",
        ...(groupIds.length > 0 ? { groupIds } : {}),
      },
    });
    setEditModal(false);
  };

  return (
    <div>
      <div className="custom-input-container">
        <Modal
          size="lg"
          isOpen={editModal}
          toggle={() => setEditModal(!editModal)}
          centered
        >
          <ModalHeader toggle={() => setEditModal(false)}>
            Configurar Email
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <Form>
                  <FormGroup className="input-margin-btm">
                    <Label htmlFor="edit-input-text" className="form-label">
                      Nome do Campo
                    </Label>
                    <Input
                      id="edit-input-text"
                      className="form-control"
                      type="text"
                      value={label}
                      onChange={({ target }) => setLabel(target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="input-margin-btm">
                    <Label
                      htmlFor="edit-input-placeholder"
                      className="form-label"
                    >
                      Texto do placeholder
                    </Label>
                    <Input
                      id="edit-input-placeholder"
                      className="form-control"
                      type="text"
                      value={placeholder}
                      onChange={({ target }) => setPlaceholder(target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="input-margin-btm">
                    <Input
                      className="input-mg-rgt"
                      id="edit-input-has-tip"
                      type="checkbox"
                      checked={hasTip}
                      onChange={({ target }) => setHasTip(target.checked)}
                    />
                    <Label htmlFor="edit-input-has-tip" className="form-label">
                      Possui dica?
                    </Label>
                    {hasTip && (
                      <FormGroup>
                        <Label htmlFor="edit-input-tip" className="form-label">
                          Texto da dica
                        </Label>
                        <Input
                          id="edit-input-tip"
                          className="form-control"
                          type="text"
                          value={tipText}
                          onChange={({ target }) => setTipText(target.value)}
                        />
                      </FormGroup>
                    )}
                  </FormGroup>
                </Form>
              </Col>
              <Col style={{ borderLeft: "1px solid gray" }}>
                <div style={{ display: "flex" }}>
                  <Label className="form-label" htmlFor="formText">
                    {label === "Email" ? (
                      `${label}*`
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: label }} />
                    )}
                  </Label>
                  {hasTip && (
                    <div>
                      <div className="show-tips" id="email-input-tip">
                        <span>?</span>
                      </div>
                      <UncontrolledTooltip
                        style={{ backgroundColor: "#6f42c1" }}
                        placement="right"
                        target="email-input-tip"
                      >
                        {tipText}
                      </UncontrolledTooltip>
                    </div>
                  )}
                </div>
                <Input
                  className="form-control"
                  type="text"
                  id="formText"
                  placeholder={placeholder}
                  value={maskedValue}
                  onChange={({ target }) => handleChange(target.value)}
                />
                {emailError && (
                  <span style={{ color: "red", fontSize: "0.85em" }}>
                    {emailError}
                  </span>
                )}
              </Col>
            </Row>
            <div className="save-btn-form-container">
              <Button
                color="success"
                className="btn btn-success waves-effect waves-light save-btn-form"
                onClick={submitForm}
              >
                Salvar
              </Button>
            </div>
          </ModalBody>
        </Modal>
        <div>
          <div className="displayed-config-container">
            <div className="displayed-label">
              <Label className="form-label" htmlFor="formText">
                {label === "Email" ? (
                  `${label}*`
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: label }} />
                )}
              </Label>
              {hasTip && (
                <div>
                  <div className="show-tips" id="email-display-tip">
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target="email-display-tip"
                  >
                    {tipText}
                  </UncontrolledTooltip>
                </div>
              )}
            </div>
            <div className="config-form-icon">
              <span
                className="mdi mdi-cog-outline"
                onClick={() => setEditModal(!editModal)}
              />
              <span
                className="mdi mdi-close close-icon"
                title="Remover Campo"
                onClick={() => deleteComponent(rowId, colId)}
              />
            </div>
          </div>
          <Input
            className="form-control"
            type="text"
            id="formText"
            placeholder={placeholder}
            value={maskedValue}
            onChange={({ target }) => handleChange(target.value)}
          />
          {emailError && (
            <span style={{ color: "red", fontSize: "0.85em" }}>
              {emailError}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
